let url = window.location.hostname,
    env,
    idx;
idx = url.indexOf('-');
if (window.location.hostname === 'localhost') {
    env = 'int-';
} else if (idx > 0) {
    //int, qa, stg
    env = url.substring(0, idx + 1);
} else {
    //production
    env = 'prod-';
}

//Check for prod to not put prod
export const envCheck = env !== 'prod-' ? env : '';

export const AFTER_ACTION_PATH = `https://${envCheck}ems.marines.com/afteraction/list`;
export const CREATE_EVENT_PATH = `https://${envCheck}ems.marines.com/event/create`;
export const SUBMIT_EVENT_PATH = `https://${envCheck}ems.marines.com/event/submit`;
export const EVENT_REPORT_PATH = `https://${envCheck}ems.marines.com/report/search`;
export const EVENT_SOURCE_CODE_PATH = `https://${envCheck}ems.marines.com/event/sourcecode`;
export const EVENT_ADREQUEST_PATH = `https://${envCheck}ems.marines.com/event/adrequest`;
export const AFTER_ACTION_SUMMARY_PATH = `https://${envCheck}ems.marines.com/event/summary`;
export const PURCHASE_REQUEST = `https://${envCheck}ems.marines.com/purchaserequest`;
export const PURCHASE_REQUEST_ITEM = `https://${envCheck}ems.marines.com/purchaserequestitem`;
export const PURCHASE_REQUEST_PATH = `https://${envCheck}ems.marines.com/purchaserequest/list`;
export const PURCHASE_REQUEST_SUMMARY_PATH = `https://${envCheck}ems.marines.com/purchaserequest/summary`;
export const PURCHASE_REQUEST_DD1535 = `https://${envCheck}ems.marines.com/purchaserequest/dd1535`;
export const PURCHASE_REQUEST_UPDATE = `https://${envCheck}ems.marines.com/purchaserequest/update`;
export const EVENT_SEARCH_PATH = `https://${envCheck}ems.marines.com/event/search`;
export const FETCH_SEARCH_PATH = `https://${envCheck}ems.marines.com/event/`;
export const EVENT_STATS_PATH = `https://${envCheck}ems.marines.com/event/stats`;
export const EVENT_TASK_PATH = `https://${envCheck}ems.marines.com/task/search`;
export const EVENT_DETAIL_PATH = `https://${envCheck}ems.marines.com/event`;
export const EVENT_COMMENT_PATH = `https://${envCheck}ems.marines.com/eventcomment`;
export const TASK_PATH = `https://${envCheck}ems.marines.com/task`;
export const USER_INFO_PATH = `https://${envCheck}ems.marines.com/user/info`;
export const VERIFY_TOKEN_PATH = `https://${envCheck}auth.marines.com/auth/verify`;
export const LOGIN = `https://${envCheck}auth.marines.com/auth/login`;
export const SESSION = `https://${envCheck}auth.marines.com/auth/session`;
export const REFRESH_TOKEN_PATH = `https://${envCheck}auth.marines.com/auth/refresh`;
export const REDIRECT_AD_PORTAL = `https://${envCheck}adportal.marines.com`; // results in int-adportal.marines.com
export const LOCATION_DISTRICT_LIST = `https://${envCheck}ems.marines.com/district/list?regionCode=`;
export const LOCATION_RS_LIST = `https://${envCheck}ems.marines.com/rs/list?districtCode=`;
export const LOCATION_RSS_LIST = `https://${envCheck}ems.marines.com/rss/list?recruitingStationCode=`;
export const LOCATION_OSS_LIST = `https://${envCheck}ems.marines.com/oss/list?recruitingStationCode=`;
export const VENDOR_SEARCH_PATH = `https://${envCheck}ems.marines.com/vendor/search?name=`;
export const CATEGORY_PATH = `https://${envCheck}ems.marines.com/category/list`;
export const MEDIA_UPLOAD = `https://${envCheck}ems.marines.com/media/create`;
export const MEDIA = `https://${envCheck}ems.marines.com/media`;
export const VENDOR_PATH = `https://${envCheck}ems.marines.com/vendor`;
export const EVENT_VENDOR_PATH = `https://${envCheck}ems.marines.com/eventvendor`;
export const BASE_EVENT_REPORT_PATH = `https://${envCheck}ems.marines.com/report`;
export const BASE_COMMENT_PATH = `https://${envCheck}ems.marines.com/eventcomment`;
export const EVENT_REPORT_COMMENT_PATH = `https://${envCheck}ems.marines.com/reportcomment`;
export const PROMO_ITEMS = `https://${envCheck}ems.marines.com/promoitem`;
export const EVENT_PROMO_ITEMS = `https://${envCheck}ems.marines.com/eventpromoitem`;
export const ONSITE_DATE_PATH = `https://${envCheck}ems.marines.com/onsitedate`;
export const LEAD_COUNT = `https://${envCheck}ems.marines.com/event/leadcount/`;

export const ASSIGNED_LOCATION_DISTRICT_LIST = `https://${envCheck}auth.marines.com/district`;
export const ASSIGNED_LOCATION_REGION_LIST = `https://${envCheck}auth.marines.com/region`;
export const ASSIGNED_LOCATION_RS_LIST = `https://${envCheck}auth.marines.com/rs`;
export const ASSIGNED_LOCATION_RSS_LIST = `https://${envCheck}auth.marines.com/rss`;
export const ASSIGNED_LOCATION_OSS_LIST = `https://${envCheck}auth.marines.com/oss`;
export const ASSIGNED_LOCATION_PSS_LIST = `https://${envCheck}auth.marines.com/pss`;

export const AUTH_USER_SEARCH = `https://${envCheck}auth.marines.com/user/search`;
export const EMS = `https://${envCheck}ems.marines.com/`;



// WEBPACK FOOTER //
// ./src/helpers/endpoints.js